module.exports = __webpack_public_path__ + "fonts/Simply Rounded Italic.d7fd16f3.ttf";